// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/stylesheets/identity.css
// module id = 7
// module chunks = 0